export default __webpack_public_path__ + "img/Poppins-Medium_f8914bc.eot";